import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { EaDisplay } from '@app/components/pr-display';
import { PrModalComponent } from '../pr-modal/pr-modal.component';

@Component({
    selector: 'pr-modal-confirm',
    templateUrl: './pr-modal-confirm.component.html',
    styleUrls: ['./pr-modal-confirm.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrModalConfirmComponent implements AfterViewInit {
  @ViewChild(PrModalComponent, { static: true }) modal: PrModalComponent;

  disabledSubmit: boolean = false;

  @Input() display: EaDisplay;
  @Input() displayOptionnal: EaDisplay;
  @Input() icon: string;
  @Input() title: string = 'Confirmation';
  @Input() comment: string;
  @Input() labelConfirm: string;
  @Input() labelCancel: string;
  @Input() optionnalLabel: string;
  @Input() showConfirm: boolean = true;
  @Input() showCancel: boolean = true;

  @Output() onConfirm = new EventEmitter<any>();
  @Output() onConfirmOptionnal = new EventEmitter<any>();

  constructor() {}

  ngAfterViewInit(): void {}

  open() {
    this.disabledSubmit = false;
    this.modal.open();
  }

  close() {
    this.modal.close();
  }

  confirm(event: Event) {
    this.disabledSubmit = true;
    this.onConfirm.emit(event);
    this.close();
  }

  optionnalConfirm(event: Event) {
    this.onConfirmOptionnal.emit(event);
    this.close();
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: any) {
    if (this.modal.isOpen && (event.keyCode === 13 || event.keyCode === 32)) {
      event.stopPropagation();
      this.confirm(event);
      return false;
    }
  }
}
